<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="this.$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!this.$route.meta.keepAlive"></router-view>

    <tabbar></tabbar>
  </div>
</template>
<script>
window.onload = function () {
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault()
  })
}
import tabbar from '@/components/Tabbar'
export default {
  // data () {
  //   return {
  //     cancelKeepAlive: true
  //   }
  // },
  components: {
    tabbar,
  }
}
</script>
<style lang="scss">
body,
html {
  // padding-bottom: 2rem;
  background: #f6f6f6;
  padding-top: env(safe-area-inset-top);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  padding-bottom: env(safe-area-inset-bottom);
  overflow: auto;
}
img {
  width: 100%;
  height: 100%;
}
ul,
li {
  list-style-type: none;
}
</style>
